import { Stack } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { InspirationTimeline } from "web_myplann/Inspiration/Components/InspirationTimeline";
import { AffordabilitySection } from "web_myplann/Inspiration/OwnHome/Components/AffordabilitySection";
import { DownPaymentSection } from "web_myplann/Inspiration/OwnHome/Components/DownPaymentSection";
import { ExpensesNudge } from "web_myplann/Inspiration/OwnHome/Components/ExpensesNudge";
import { RentVsOwnComparison } from "web_myplann/Inspiration/OwnHome/Components/RentVsOwnComparison";
import { OWN_HOME_TIMELINE_STEPS } from "web_myplann/Inspiration/OwnHome/constants";
import type { OwnHomeContext } from "web_myplann/Inspiration/OwnHome/Types/OwnHomeTypes";

type Props = {
	context: OwnHomeContext;
	onEditAffordability: () => void;
	onAddExpenses: () => void;
};

export const OwnHomeResult: FC<Props> = ({
	context,
	onEditAffordability,
	onAddExpenses,
}) => {
	const { t } = useResource();

	const showDownPayment =
		context.state === "full" &&
		context.hasSavings &&
		(context.savingsGap ?? 0) > 0;

	return (
		<Stack mt={0.8} gap={0.8}>
			<RentVsOwnComparison context={context} />
			<AffordabilitySection context={context} onEdit={onEditAffordability} />
			{context.state === "affordability" && (
				<ExpensesNudge onClick={onAddExpenses} />
			)}
			{showDownPayment && <DownPaymentSection context={context} />}
			<InspirationTimeline
				title={t(Resources.Inspiration.OwnHome.Result.timelineTitle)}
				steps={OWN_HOME_TIMELINE_STEPS}
			/>
		</Stack>
	);
};
